'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;
// import iconBack from './arrow-back.png';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDraggable = require('react-draggable');

var _reactDraggable2 = _interopRequireDefault(_reactDraggable);

var _reactBootstrap = require('react-bootstrap');

var _reactDropzone = require('react-dropzone');

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

var _shops = require('redux/modules/shops');

var shopActions = _interopRequireWildcard(_shops);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _lodash = require('lodash');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadingIcon = '/actions/load.gif';

// import Select from 'react-select';
function setPointRaiting(dx, config) {
  if (config) {
    var min = config.min,
        max = config.max,
        _step = config.step;

    var _nstep = (max - min) / _step;
    var _widthRange = document.getElementById('rating-bar').offsetWidth / 2;
    var pixelPerStep = _widthRange * 2 / _nstep;
    var value = _widthRange + dx;
    var pointOfNStep = value / pixelPerStep;
    var realPointOfStep = Math.floor(pointOfNStep);
    // realPointOfStep đang lấy phần nguyên đồng nghĩa là đang làm tròn xuống.
    var _decPart = pointOfNStep - realPointOfStep;
    if (_decPart >= 0.5) {
      // Làm tròn lên
      realPointOfStep = realPointOfStep + 1;
    }
    var _point = min + realPointOfStep * _step;
    var realTimePoint = min + pointOfNStep * _step;
    var average = (max + min) / 2;
    return {
      point: _point,
      progressPoint: realTimePoint,
      position: {
        x: (_point - average) * pixelPerStep / _step,
        y: 0
      }
    };
  }
  var widthRange = (document.getElementById('rating-bar').offsetWidth - 24) / 2;
  var step = widthRange / 10;
  var nstep = Math.round(dx / step * 10) / 10;
  var point = Math.round(nstep / 2 * 10) / 10;
  var realPoint = point + 5;
  var decPart = (realPoint + '').split('.')[1];
  var floor = Math.floor(realPoint);
  if (decPart) {
    if (decPart >= 8 || decPart >= 3) {
      // TODO: làm tròn lên 0.5 hoặc 1
      var more = decPart >= 8 ? 1 : 0.5;
      realPoint = floor + more;
    } else {
      // TODO: làm tròn xuống 0.5 hoặc 1
      realPoint = decPart < 3 ? floor : floor + 0.5;
    }
  }
  var ratingPoint = realPoint;
  if (ratingPoint <= 1) {
    ratingPoint = 1;
  }
  return {
    ratingPoint: ratingPoint,
    position: {
      x: (realPoint - 5) * step * 2,
      y: 0
    }
  };
}

var NewReviewMobile = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    shop: state.shops.shop,
    loadingSubmit: state.reviews.posting,
    postSuccess: state.reviews.success,
    reviewSuggest: state.shops.reviewSuggest
  };
}, (0, _extends3.default)({}, setupActions, { newReview: _shops.newReview }, shopActions)), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(NewReviewMobile, _Component);

  function NewReviewMobile() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, NewReviewMobile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = NewReviewMobile.__proto__ || (0, _getPrototypeOf2.default)(NewReviewMobile)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      comment: [],
      images: [],
      otherComment: '',
      mark: 1,
      showModalSuccess: false,
      errorMsg: '',
      configRating: {
        active: '',
        progressPoint: 9,
        point: 9,
        min: 8,
        max: 10,
        step: 0.5
      },
      position: { x: 0, y: 0 }
    }, _this.confirmSuccess = function () {
      _this.handleCloseModalSuccess();
      _reactRouter.browserHistory.goBack();
    }, _this.onClickGoBack = function () {
      _reactRouter.browserHistory.goBack();
    }, _this.handleChangeComment = function (event) {
      var value = event.target.value;
      _this.setState({
        otherComment: value
      });
    }, _this.handleDrag = function (event, data) {
      var result = setPointRaiting(data.x, _this.state.configRating);
      var config = (0, _extends3.default)({}, _this.state.configRating, {
        point: result.point,
        progressPoint: result.progressPoint
      });
      _this.setState({ configRating: config });
      var mark = void 0;
      if (result.point >= 0 && result.point <= 6) {
        mark = 1;
      } else if (result.point > 6 && result.point < 8) {
        mark = 2;
      } else {
        mark = 3;
      }
      var comment = void 0;
      if (mark !== _this.state.mark) {
        comment = [];
        _this.setState({
          comment: comment,
          mark: mark
        });
      }
    }, _this.handleChangeOtherComment = function (event) {
      var value = event.target.value;
      _this.setState({ otherComment: value });
    }, _this.handleSubmitReview = function () {
      var shopId = _this.props.shop._id;
      var _this$state = _this.state,
          comment = _this$state.comment,
          otherComment = _this$state.otherComment,
          images = _this$state.images;
      var ratingPoint = _this.state.configRating.point;

      if (comment.length === 0 && otherComment.length === 0) {
        alert('Vui lòng nhập nội dung bình luận.');
        return;
      }
      var hasOtherComment = true;
      var stringCmt = '';
      var firstCmt = true;
      comment.map(function (cmt) {
        if (firstCmt) {
          stringCmt += cmt;
          firstCmt = false;
        } else {
          stringCmt += '. ' + cmt;
        }
      });
      if (hasOtherComment) {
        if (firstCmt) {
          stringCmt += otherComment;
          firstCmt = false;
        } else {
          stringCmt += '. ' + otherComment;
        }
      }
      var data = {
        shopId: shopId,
        comment: stringCmt,
        ratingPoint: ratingPoint,
        userId: _this.props.user._id
      };
      _this.props.newReview(data, images);
      setTimeout(function () {
        return _reactRouter.browserHistory.goBack();
      }, 500);
    }, _this.handleCloseModalSuccess = function () {
      _this.setState({
        showModalSuccess: false
      });
    }, _this.handleChangeCommentTemplates = function (value) {
      var comment = _this.state.comment.slice();
      var index = comment.indexOf(value);
      if (index !== -1) {
        comment.splice(index, 1);
      } else {
        comment.push(value);
      }
      _this.setState({
        comment: comment
      });
    }, _this.handleShowModalSuccess = function () {
      _this.setState({
        showModalSuccess: true
      });
    }, _this.setComment = function (event) {
      _this.setState(function (prevState) {
        return (0, _extends3.default)({}, prevState, {
          comment: event
        });
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(NewReviewMobile, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.getShopData(this.props.params.shopHandle);
      this.props.getReviewSuggest();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var changeHeader = this.props.changeHeader;

      if (!(0, _lodash.isEqual)(this.props.shop, nextProps.shop) && nextProps.shop) {
        changeHeader({ back: true, title: nextProps.shop.name });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.postSuccess) {
        this.handleShowModalSuccess();
        this.props.resetStatusSuccess();
      }
    }
  }, {
    key: 'onDrop',
    value: function onDrop(acceptedFiles) {
      var totalSize = 0;
      acceptedFiles.map(function (file) {
        return totalSize += file.size;
      });
      if (totalSize > 10000000) {
        this.setState({
          errorMsg: 'Dung lượng hình ảnh quá lớn, vui lòng chọn hình ảnh có tổng dung lượng nhỏ hơn 10 MB'
        });
        return;
      }
      this.setState({ images: acceptedFiles, errorMsg: '' });
    }
  }, {
    key: 'handleStop',
    value: function handleStop(e, d) {
      var result = setPointRaiting(d.x, this.state.configRating);
      var config = (0, _extends3.default)({}, this.state.configRating, {
        point: result.point,
        progressPoint: result.point
      });
      this.setState({ configRating: config, position: result.position });
    }
  }, {
    key: 'handleClickRaitingBar',
    value: function handleClickRaitingBar(e) {
      var widthRange = document.getElementById('rating-bar').offsetWidth / 2;
      var dx = e.clientX - widthRange - 10;
      var result = setPointRaiting(dx, this.state.configRating);
      var config = (0, _extends3.default)({}, this.state.configRating, {
        point: result.point,
        progressPoint: result.point
      });
      this.setState({ configRating: config, position: result.position });
    }
  }, {
    key: 'isIcon',
    value: function isIcon(name, sactive) {
      var active = this.state.configRating.active;

      return active === name ? sactive : '';
    }
  }, {
    key: 'handleIcon',
    value: function handleIcon(name) {
      var position = { x: 0, y: 0 };
      var reviewSuggest = this.props.reviewSuggest;

      var config = (0, _extends3.default)({}, this.state.configRating, { active: name });
      switch (name) {
        case 'good':
          config = (0, _extends3.default)({}, config, {
            point: 9,
            progressPoint: 9
          }, reviewSuggest[3]);
          break;
        case 'normal':
          config = (0, _extends3.default)({}, config, {
            point: 7,
            progressPoint: 7
          }, reviewSuggest[2]);
          break;
        case 'bad':
          config = (0, _extends3.default)({}, config, {
            point: 5,
            progressPoint: 5
          }, reviewSuggest[1]);
          break;
        case 'poor':
          config = (0, _extends3.default)({}, config, {
            point: 2.5,
            progressPoint: 2.5
          }, reviewSuggest[0]);
          break;
        default:
          break;
      }
      this.setState({ configRating: config, position: position, comment: [] });
    }
  }, {
    key: 'getClassType',
    value: function getClassType(type) {
      var styles = require('./NewReviewMobile.scss');
      switch (type) {
        case 'normal':
          return styles.normal;
        case 'bad':
          return styles.bad;
        case 'poor':
          return styles.poor;
        default:
          return '';
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./NewReviewMobile.scss');
      var _state = this.state,
          images = _state.images,
          otherComment = _state.otherComment,
          showModalSuccess = _state.showModalSuccess,
          errorMsg = _state.errorMsg,
          comment = _state.comment,
          configRating = _state.configRating;
      var _props = this.props,
          shop = _props.shop,
          loadingSubmit = _props.loadingSubmit;

      var options = configRating && configRating.suggests ? configRating.suggests : [];
      if (!shop) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: styles.newReviewMobile },
        loadingSubmit && _react2.default.createElement(
          'div',
          { className: styles.loadingFade },
          _react2.default.createElement(
            'div',
            { className: styles.loading },
            _react2.default.createElement('img', { src: loadingIcon }),
            _react2.default.createElement(
              'div',
              { className: styles.loadingText },
              '\u0110ang g\u1EEDi ...'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.reviewForm },
          _react2.default.createElement(
            'div',
            { className: styles.reviewHead },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              ' \u0110\xE1nh gi\xE1'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.reviewBody },
            _react2.default.createElement(
              'div',
              { className: styles.rrow },
              _react2.default.createElement(
                'div',
                { className: styles.rtitle },
                'C\xE2u h\u1ECFi 1'
              ),
              _react2.default.createElement(
                'div',
                { className: styles.rcontent },
                'B\u1EA1n c\xF3 h\xE0i l\xF2ng v\u1EDBi d\u1ECBch v\u1EE5 t\u1EA1i "',
                _react2.default.createElement(
                  'b',
                  null,
                  shop.name
                ),
                '"?'
              ),
              _react2.default.createElement(
                'div',
                { className: styles.ricons },
                _react2.default.createElement('div', {
                  className: styles.icon + ' ' + styles.poor + ' ' + this.isIcon('poor', styles.active),
                  onClick: function onClick() {
                    return _this2.handleIcon('poor');
                  }
                }),
                _react2.default.createElement('div', {
                  className: styles.icon + ' ' + styles.bad + ' ' + this.isIcon('bad', styles.active),
                  onClick: function onClick() {
                    return _this2.handleIcon('bad');
                  }
                }),
                _react2.default.createElement('div', {
                  className: styles.icon + ' ' + styles.normal + ' ' + this.isIcon('normal', styles.active),
                  onClick: function onClick() {
                    return _this2.handleIcon('normal');
                  }
                }),
                _react2.default.createElement('div', {
                  className: styles.icon + ' ' + styles.good + ' ' + this.isIcon('good', styles.active),
                  onClick: function onClick() {
                    return _this2.handleIcon('good');
                  }
                })
              )
            ),
            _react2.default.createElement(
              'div',
              {
                className: this.state.configRating.active === '' ? 'phide' : ''
              },
              _react2.default.createElement(
                'div',
                { className: styles.rrow },
                _react2.default.createElement(
                  'div',
                  { className: styles.rtitle },
                  'C\xE2u h\u1ECFi 2'
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.rcontent },
                  'Tuy\u1EC7t v\u1EDDi, s\u1EF1 h\xE0i l\xF2ng c\u1EE7a b\u1EA1n t\u01B0\u01A1ng \u0111\u01B0\u01A1ng bao nhi\xEAu \u0111i\u1EC3m?'
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.rprogress },
                  _react2.default.createElement(
                    'div',
                    { className: styles.progressBarContainer },
                    _react2.default.createElement(
                      _reactDraggable2.default,
                      {
                        ref: 'draggable',
                        axis: 'x',
                        bounds: 'parent',
                        defaultPosition: { x: 0, y: 0 },
                        position: {
                          x: this.state.position.x,
                          y: this.state.position.y
                        },
                        onDrag: function onDrag(event, data) {
                          return _this2.handleDrag(event, data);
                        },
                        onStop: function onStop(e, d) {
                          return _this2.handleStop(e, d);
                        }
                      },
                      _react2.default.createElement(
                        'div',
                        {
                          className: styles.selectCircle + ' ' + this.getClassType(configRating.active)
                        },
                        configRating.point.toString().length === 1 || configRating.point === 10 ? configRating.point.toString() + '.0' : configRating.point
                      )
                    ),
                    _react2.default.createElement(
                      _reactBootstrap.ProgressBar,
                      {
                        id: 'rating-bar',
                        className: 'psuccess ' + configRating.active,
                        onClick: function onClick(e) {
                          return _this2.handleClickRaitingBar(e);
                        }
                      },
                      _react2.default.createElement(_reactBootstrap.ProgressBar, {
                        now: configRating.progressPoint,
                        min: configRating.min,
                        max: configRating.max
                      })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.pointLabel },
                      _react2.default.createElement(
                        'div',
                        { className: styles.point1 },
                        configRating.min
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: styles.point5 },
                        (configRating.min + configRating.max) / 2
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: styles.point10 },
                        configRating.max
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.rrow + ' ' + styles.mT50 },
                _react2.default.createElement(
                  'div',
                  { className: styles.rtitle },
                  'Nh\u1EADn x\xE9t nhanh'
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.rslogan },
                  'B\u1EA1n c\xF3 th\u1EC3 ch\u1ECDn nhi\u1EC1u nh\u1EADn x\xE9t nhanh cho c\u1EEDa h\xE0ng'
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.rcomment },
                  _react2.default.createElement(
                    'div',
                    { className: styles.inputComment },
                    options.map(function (opt, index) {
                      return _react2.default.createElement(
                        'div',
                        {
                          className: styles.label + (comment.indexOf(opt) === -1 ? '' : ' ' + styles.active),
                          key: index,
                          onClick: function onClick() {
                            return _this2.handleChangeCommentTemplates(opt);
                          }
                        },
                        opt
                      );
                    })
                  ),
                  _react2.default.createElement('textarea', {
                    className: styles.inputOtherComment,
                    type: 'text',
                    placeholder: 'Nh\u1EADn x\xE9t kh\xE1c',
                    value: otherComment,
                    rows: '3',
                    onChange: function onChange(event) {
                      return _this2.handleChangeOtherComment(event);
                    }
                  })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.rrow + ' ' + styles.mT20 },
                _react2.default.createElement(
                  'div',
                  { className: styles.rtitle },
                  'H\xECnh \u1EA3nh/Video'
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.rimage },
                  _react2.default.createElement(
                    'div',
                    { className: styles.listImages },
                    _react2.default.createElement(
                      _reactDropzone2.default,
                      {
                        className: styles.dropZone + ' dropzone',
                        onDrop: this.onDrop.bind(this),
                        multiple: true,
                        accept: 'image/*'
                      },
                      _react2.default.createElement('div', { className: styles.addImageVideo })
                    ),
                    images.length > 0 && _react2.default.createElement(
                      'div',
                      null,
                      images.map(function (image, index) {
                        // const imgBackGr = {backgroundImage: `url(${image.preview})`};
                        return image.type.split('/')[0] === 'video' ? _react2.default.createElement(
                          'div',
                          { key: image.lastModified },
                          _react2.default.createElement('video', {
                            src: image.preview,
                            key: image.lastModified + '_' + index,
                            width: '100%',
                            height: '250px',
                            controls: true
                          })
                        ) : _react2.default.createElement('img', {
                          src: image.preview,
                          key: image.lastModified + '_' + index,
                          className: styles.thumbImage
                        });
                      })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.errorMessage },
                      errorMsg
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.reviewFoot },
            _react2.default.createElement(
              'div',
              {
                className: styles.submitReviewBtn + (otherComment.length === 0 && comment.length === 0 ? ' ' + styles.inactive : ''),
                onClick: function onClick() {
                  return _this2.handleSubmitReview();
                }
              },
              'G\u1EEDi \u0110\xE1nh Gi\xE1'
            )
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal,
          {
            show: showModalSuccess,
            hide: this.handleCloseModalSuccess,
            className: 'modal-alert-mobile'
          },
          _react2.default.createElement(
            'div',
            { className: styles.modalAlert },
            _react2.default.createElement(
              'div',
              { className: styles.headerAlert },
              'Th\xF4ng b\xE1o'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.contentAlert },
              'G\u1EEDi b\xECnh lu\u1EADn th\xE0nh c\xF4ng'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.actionButtons },
              _react2.default.createElement(
                'div',
                {
                  className: styles.btnLogin,
                  onClick: function onClick() {
                    return _this2.confirmSuccess();
                  }
                },
                'X\xE1c nh\u1EADn'
              )
            )
          )
        )
      );
    }
  }]);
  return NewReviewMobile;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  params: _react.PropTypes.object,
  shop: _react.PropTypes.object,
  reviewSuggest: _react.PropTypes.array,
  push: _react.PropTypes.func,
  newReview: _react.PropTypes.func,
  loadingSubmit: _react.PropTypes.bool,
  postSuccess: _react.PropTypes.bool,
  changeHeader: _react.PropTypes.func,
  resetStatusSuccess: _react.PropTypes.func,
  getShopData: _react.PropTypes.func,
  getReviewSuggest: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = NewReviewMobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/NewReview/NewReviewMobile.js
// module id = 1613
// module chunks = 0